import Swiper from 'swiper/bundle';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import heroSlider from '../utils/heroSlider';
import scroll from '../utils/scroll';
import {setTimeout} from "../../js/concat/utils_concat";

gsap.registerPlugin(ScrollTrigger);

const landing = {
    init() {
        this.initSwipers();
        this.initServices();
        heroSlider.init();
        setTimeout(this.initMap(),1500);
        //this.initMap();
    },
    initSwipers() {
        const swiper_temoignages = new Swiper('.__temoignages', {
            direction: 'horizontal',
            spaceBetween: 10,
            autoHeight: true,
            // 👇 Ajout navigation
            navigation: {
                nextEl: '.__btn_nav._next',
                prevEl: '.__btn_nav._prev',
            },
            // 👇 Navigation via clavier
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            // 👇 Navigation via molette (scroll horizontal)
            mousewheel: {
                forceToAxis: true, // évite scroll vertical par défaut
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.05,
                    spaceBetween: 0,
                },
                600: {
                    slidesPerView: 1.3,
                },
                900: {
                    slidesPerView: 1.8,
                },
                1300: {
                    slidesPerView: 2.1,
                },
                1500: {
                    slidesPerView: 2.3,
                },
            }
        });
    },
    initMap() {
        // Latitude and longitude of the address
        const location = {lat: 45.7645, lng: 4.8554};

        const mapStyles = [
            {
                "elementType": "geometry",
                "stylers": [
                    {"color": "#FDFBF6"} // Fond général en blanc cassé
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {"visibility": "off"} // Suppression des icônes superflues
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {"color": "#757575"} // Texte légèrement contrasté pour lisibilité
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {"color": "#FDFBF6"} // Fond des labels en blanc cassé
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#e5e5e5"} // Délimitation des zones ultra discrète
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#f8f8f8"} // Points d'intérêt légèrement perceptibles
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {"color": "#848484"} // Labels des POI contrastés
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#f5f5f5"} // Routes très claires
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#f0f0f0"} // Routes secondaires légèrement visibles
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#e5e5e5"} // Autoroutes plus visibles mais sobres
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {"color": "#616161"} // Texte autoroutes pour contraste
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#f8f8f8"} // Eau presque blanche, très douce
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {"color": "#a0a0a0"} // Noms des rivières/lacs légèrement visibles
                ]
            }
        ];


        // Create the map
        const map = new google.maps.Map(document.getElementById("map"), {
            center: location,
            zoom: 15, // Adjust zoom level
            disableDefaultUI: true, // Disable default UI
            zoomControl: false, // Enable zoom controls
            zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT, // Position in the top right
            },
            styles: mapStyles
        });

        const markerSize = window.innerWidth > 768
            ? {width: 100, height: 97} // Large icône
            : {width: 60, height: 58}; // Petite icône

        const markerIcon = {
            url: _SITE_URL + "img/SITE/LANDING/marker_map.png?v=50", // Chemin de l'image
            scaledSize: new google.maps.Size(markerSize.width, markerSize.height), // Taille du marqueur
            origin: new google.maps.Point(0, 0), // Origine de l'image
            anchor: new google.maps.Point(markerSize.width / 2, markerSize.height / 2) // Ancrage au centre
        };

        // Add custom marker
        new google.maps.Marker({
            position: location,
            map: map,
            icon: markerIcon
        });
    },
    initServices() {
        $(document).on("click", "._service > h3", function () {
            let _elt = $(this).parent();
            _elt.toggleClass("_open");
            $("._service").not(_elt).removeClass("_open");
            setTimeout(function(){
                scroll.locomotiveScroll.scrollTo(_elt[0], {duration: 1.2, offset: -100, disableLerp: true});
            },200);

            scroll.update();
            ScrollTrigger.refresh();
        });
    },
};

export default landing;
